// extracted by mini-css-extract-plugin
module.exports = {"smallImage":"style_smallImage__2D5mM","userName":"style_userName__3QDVz","navWrapper":"style_navWrapper__3Oim7","navList":"style_navList__3CRCX","listItem":"style_listItem__2v4Bk"};